
import React, { useState,useEffect } from "react";

const documents = [
 {
  id: 1,
  category: "Analytics & Insights",
  title: "2023 Data Validation Summary",
  description: "Detailed analysis of the 2023 data validation processes and performance metrics.",
  image: "/assets/sql.png",
  link: "/PDF/Data&Analytics/DataValidation2023.pdf",
},
{
  id: 2,
  category: "Analytics & Insights",
  title: "Q2 Data Review Report",
  description: "Insights and validation outcomes from the second quarter of 2023.",
  image: "/assets/datavalidation3.jpg",
  link: "/PDF/Data&Analytics/DataValidationReportQ2.pdf",
},
{
  id: 3,
  category: "Analytics & Insights",
  title: "Q1 Data Review Report",
  description: "Evaluation of data integrity and accuracy for Q1 of 2023.",
  image: "/assets/unnamed.jpg",
  link: "/PDF/Data&Analytics/Q1DataValidationReport.pdf",
},
 {
  id: 4,
  category: "Data Management Report",
  title: "2022  Data Report",
  description: "Comprehensive overview of data management tracking and progress for the year 2022.",
  image: "/assets/d1.jpg",
  link: "/PDF/ProgramReports/2022InternalDataManagementTrackerProgressReport.pdf",
},
 {
  id: 5,
  category: "Data Management Report",
  title: "Pathways to Wage Employment",
  description: "Comprehensive overview of wage employment tracking and progress for the year.",
  image: "/assets/DataValidationSummer2018.jpg",
  link: "/PDF/ProgramReports/Pathwaystowageemployment.pdf",
},
];

export default function DataAnalytics() {
  useEffect(() => {
        window.scrollTo(0, 0); 
      }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);

  const itemsPerPage = 6; 
  const filteredDocs = documents.filter(
    (doc) =>
      doc.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      doc.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredDocs.length / itemsPerPage);
  const startIndex = page * itemsPerPage;
  const paginatedDocs = filteredDocs.slice(startIndex, startIndex + itemsPerPage);

  const handleNext = () => {
    if (page < totalPages - 1) setPage(page + 1);
  };

  const handlePrev = () => {
    if (page > 0) setPage(page - 1);
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-orange mb-6 text-center">
        Knowledge Management Library
      </h1>

      <div className="max-w-2xl mx-auto mb-8">
        <input
          type="text"
          placeholder="Search documents..."
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400"
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setPage(0); 
          }}
        />
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
        {paginatedDocs.map((doc) => (
          <div
            key={doc.id}
            className="bg-white rounded-xl shadow hover:shadow-md p-4"
          >
            <img
              src={doc.image}
              alt={doc.title}
              className="h-40 w-full object-cover rounded-md mb-4"
            />
            <h3 className="text-lg font-semibold text-gray-800">
              {doc.title}
            </h3>
            <p className="text-sm text-gray-600">{doc.description}</p>
            <a
              href={doc.link}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-block text-orange-600 hover:underline text-sm"
            >
              View Document
            </a>
          </div>
        ))}
      </div>

      
      <div className="flex justify-center gap-4">
        <button
          onClick={handlePrev}
          disabled={page === 0}
          className={`px-4 py-2 rounded-md font-semibold ${
            page === 0
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-orange text-white hover:bg-orange-600"
          }`}
        >
          Previous
        </button>
        <button
          onClick={handleNext}
          disabled={page === totalPages - 1}
          className={`px-4 py-2 rounded-md font-semibold ${
            page === totalPages - 1
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-orange text-white hover:bg-orange-600"
          }`}
        >
          Next
        </button>
      </div>
    </div>
  );
}
